import { useState } from 'react';
import { Button, Avatar, Stack, Link } from '@mui/material';
import AppsIcon from '@mui/icons-material/Apps';
import HEMTLogo from '../../assets/HEMT logo.png';
import callmartLogo from '../../assets/Callmart logo.png';
import CardPopover from '../UI/CardPopover';
import { hemtURL, appURL } from '../../config';

function AppSwitch() {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Button onClick={handleClick} style={{ color: 'white' }}>
                <AppsIcon></AppsIcon>
            </Button>
            <CardPopover anchorEl={anchorEl} onClose={handleClose}>
                <Button
                    href={hemtURL + '/profile'}
                    target="_blank"
                    rel="noopener"
                    component={Link}
                    sx={{ width: '50%' }}
                >
                    <Stack spacing={2} alignItems="center">
                        <Avatar alt="HEMT" src={HEMTLogo} />
                        <span>HEMT</span>
                    </Stack>
                </Button>
                <Button href={appURL} target="_blank" rel="noopener" component={Link} sx={{ width: '50%' }}>
                    <Stack spacing={2} alignItems="center">
                        <Avatar alt="Callmart" src={callmartLogo} />
                        <span>Callmart</span>
                    </Stack>
                </Button>
            </CardPopover>
        </>
    );
}

export default AppSwitch;
